import { TrackingServiceSegment } from "./trackingServiceSegment"
import { TrackingServiceKlaviyo } from "./trackingServiceKlaviyo"

export class TrackingManager {
  constructor(enabledServices, pipelineConfig) {
    this.services = {}
    this.serviceConstructors = {
      segment: TrackingServiceSegment,
      klaviyo: TrackingServiceKlaviyo,
    }

    // Remove duplicate tracking event names
    const uniqueEnabledServices = enabledServices.filter(
      (service, index) => enabledServices.indexOf(service) === index,
    )

    uniqueEnabledServices.forEach((service) => {
      if (this.serviceConstructors[service]) {
        this.services[service] = new this.serviceConstructors[service](pipelineConfig)
      }
    })
  }

  isDestinationSet(destination) {
    return destination && this.serviceConstructors[destination]
  }

  getSelectedService(destinationService) {
    try {
      return this.services[destinationService]
    } catch (err) {
      console.error(`[TrackingManager] Error getting selected service: ${err}`)
    }
  }

  trackClick(customData, destinationService) {
    if (this.isDestinationSet(destinationService)) {
      const service = this.getSelectedService(destinationService)
      service.trackClick(customData)
      return
    }

    Object.keys(this.services).forEach((service) => {
      this.services[service].trackClick(customData)
    })
  }

  trackPageView(customData, destinationService) {
    if (this.isDestinationSet(destinationService)) {
      const service = this.getSelectedService(destinationService)
      service.trackPageView(customData)
      return
    }

    Object.keys(this.services).forEach((service) => {
      this.services[service].trackPageView(customData)
    })
  }

  trackIdentify({ customData, destinationService, callBackFn }) {
    if (this.isDestinationSet(destinationService)) {
      const service = this.getSelectedService(destinationService)
      service.trackIdentify(customData, callBackFn)
      return
    }

    Object.keys(this.services).forEach((service) => {
      this.services[service].trackIdentify(customData, callBackFn)
    })
  }

  trackSystemEvent(customData, destinationService) {
    if (this.isDestinationSet(destinationService)) {
      const service = this.getSelectedService(destinationService)
      service.trackSystemEvent(customData)
      return
    }

    Object.keys(this.services).forEach((service) => {
      this.services[service].trackSystemEvent(customData)
    })
  }

  resetUserData(destinationService) {
    if (this.isDestinationSet(destinationService)) {
      const service = this.getSelectedService(destinationService)
      service.resetUserData()
      return
    }

    Object.keys(this.services).forEach((service) => {
      this.services[service].resetUserData()
    })
  }

  setEventToSessionStorage(customData, destinationService) {
    if (this.isDestinationSet(destinationService)) {
      const service = this.getSelectedService(destinationService)
      service.setEventToSessionStorage(customData)
      return
    }

    Object.keys(this.services).forEach((service) => {
      this.services[service].setEventToSessionStorage(customData)
    })
  }

  trackSessionStorageClickEvent(payload, destinationService) {
    if (this.isDestinationSet(destinationService)) {
      const service = this.getSelectedService(destinationService)
      service.trackSessionStorageClickEvent(customData)
      return
    }

    Object.keys(this.services).forEach((service) => {
      this.services[service].trackSessionStorageClickEvent(payload)
    })
  }

  async isUserIdentified(customData, destinationService) {
    if (this.isDestinationSet(destinationService)) {
      const service = this.getSelectedService(destinationService)
      return await service.isUserIdentified(customData)
    }

    let response = true

    for (const service of Object.keys(this.services)) {
      const responseService = await this.services[service].isUserIdentified(customData)
      if (!responseService) {
        response = false
        break
      }
    }

    return response
  }
}
